import { Record } from '@common/data-models/records/record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { DateTime } from "@common/data-models/complex-types/date-time";
import { ObjectTypes } from "@common/enums/object-types";

export class WireRecord extends Record {

    public initialize() {
        this.type = ObjectTypes.WIRE;
        super.initialize();
        super.setupRequiredFieldsGroups("Wire");
    }

    public get wireId(): string { return this.getAs<string>('wireId'); }
    public set wireId(value: string) { this.set('wireId', value); }

    public get feedId(): string { return this.getAs<string>('feedId'); }
    public set feedId(value: string) { this.set('feedId', value); }

    public get createdDate(): DateTime { return this.getAs<DateTime>('createdDate'); }
    public set createdDate(value: DateTime) { this.set('createdDate', value); }

    public get ingestedDate(): DateTime { return this.getAs<DateTime>('ingestedDate'); }
    public set ingestedDate(value: DateTime) { this.set('ingestedDate', value); }

    public get updatedDate(): DateTime { return this.getAs<DateTime>('updatedDate'); }
    public set updatedDate(value: DateTime) { this.set('updatedDate', value); }

    public get wireType(): number { return this.getAs<number>('wireType'); }
    public set wireType(value: number) { this.set('wireType', value); }

    public get wordCount(): number { return this.getAs<number>('wordCount'); }
    public set wordCount(value: number) { this.set('wordCount', value); }

    public get published(): DateTime { return this.getAs<DateTime>(PSTFieldNames.PSTWirePublished); }
    public set published(value: DateTime) { this.set(PSTFieldNames.PSTWirePublished, value); }
}
